import { render, staticRenderFns } from "./SwapDetails.vue?vue&type=template&id=0e1fd52b&scoped=true&lang=html&"
import script from "./SwapDetails.vue?vue&type=script&lang=js&"
export * from "./SwapDetails.vue?vue&type=script&lang=js&"
import style0 from "./SwapDetails.vue?vue&type=style&index=0&id=0e1fd52b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1fd52b",
  null
  
)

export default component.exports